// Facts about the mobile bottom navigation that non-nav code needs to agree
// with. They live outside Sidebar.tsx because that file exports components and
// Fast Refresh only works when a component file exports components only.

// Height (px) of the mobile bottom nav's own box, excluding
// `env(safe-area-inset-bottom)` (that part is a separate padding value,
// added by consumers via the same env() call rather than as a number, since
// it can't be summed with a px constant in JS).
export const BOTTOM_NAV_HEIGHT = 60

// Routes on which the bottom nav is not rendered at all, decided from the path
// alone. Kept separate from the transient reason the nav hides (the full-screen
// card editor) because Layout uses this one to decide
// whether to reserve bottom padding for the nav — and that reservation must
// not change while the user is typing, or the page would reflow under the
// keyboard.
//
// The deck screen is here per ADR-067 Decision 1: a learner who opened a deck
// is working with that deck, the deck owns its own bottom edge, and the nav's
// protruding centre button collides with whatever the deck pins there. The
// deck's pinned top strip is the exit, at a cost of one tap. Nav returns on
// every other screen, including on navigating back out of the deck, because
// this is a pure function of the current path with no state to leak.
export function isBottomNavRoute(pathname: string): boolean {
  const isDeckScreen = /^\/decks\/[^/]+$/.test(pathname)
  // The text screen owns its bottom edge too (handoff §9: its bar is the practice
  // bar, not the global nav): the thin top strip is its exit.
  const isTextScreen = /^\/texts\/[^/]+(\/edit(\/words)?|\/practice)?$/.test(pathname)
  return !(
    pathname.endsWith('/learn') ||
    pathname.startsWith('/onboarding') ||
    // The text creation flow is full-screen: its steps carry their own top strip
    // and bottom bar (handoff §0.3).
    pathname.startsWith('/texts/new') ||
    isDeckScreen ||
    isTextScreen
  )
}
